<template>
  <el-select v-model="targetData.snapshotInterval" @change="onChangeInterval" popper-class="snap-select-box">
    <el-option v-for="item in periodData" :key="item.snapshotInterval" :label="item.label" :value="item.snapshotInterval" ></el-option>
  </el-select>
</template>

<script>
export default {
  name: 'WSnapshotPeriodSelect',
  props: {
    targetData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      periodData: [
        {
          label: '5분',
          snapshotInterval: 5,
        },
        {
          label: '10분',
          snapshotInterval: 10,
        },
        {
          label: '15분',
          snapshotInterval: 15,
        },
        {
          label: '20분',
          snapshotInterval: 20,
        },
        {
          label: '30분',
          snapshotInterval: 30,
        },
        {
          label: '1시간',
          snapshotInterval: 60,
        },
        {
          label: '2시간',
          snapshotInterval: 120,
        },
        {
          label: '3시간',
          snapshotInterval: 180,
        },
        {
          label: '6시간',
          snapshotInterval: 360,
        },
        {
          label: '12시간',
          snapshotInterval: 720,
        },
        {
          label: '24시간',
          snapshotInterval: 1440,
        },
      ],
    };
  },
  methods: {
    onChangeInterval() {
      this.$emit('check-change-flag');
    },
  },
};
</script>
<style>
.snap-select-box .el-select-dropdown__wrap.el-scrollbar__wrap {
  height: 303px !important;
  max-height: 303px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/settings/operation/CollectionSettings/SnapshotPeriodSettings/components/SnapshotPeriodSelect.vue